/**
 * ReturnToSchedulerButton
 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../../../../../services/router/actions';

interface Props {
    updateQueryString: Function;
}

class ReturnToSchedulerButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.updateQueryString({
            eventPrintModal: undefined,
            seasonalEventModal: undefined,
            selectedEvent: undefined
        });
    };

    render(): React.ReactElement {
        return (
            <Button basic primary fluid onClick={this.handleClick}>
                Return to Scheduler
            </Button>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(ReturnToSchedulerButton);
